module.exports = "/assets/data/8ae271c5f7a6f723e92ed9427f6923ab-SO42.data.json";